export default __webpack_public_path__ + "static/media/checkmark.41572c88.svg";